const isProd = process.env.REACT_APP_ENV === "production";
const plansList = [
	{
		id: 0,
		name: "Lite",
		price: 69,
		terms: `Up to 50k sessions`,
		stripePlanId: isProd ? "price_1IVITAIt12vN5d86QQzDVLeu" : "price_1IQYjsIt12vN5d86goijkmFw",
		arrayId: "lite"
	},
	{
		id: 1,
		name: "Pro",
		price: 119,
		terms: `Up to 100k sessions`,
		stripePlanId: isProd ? "pro_m_119" : `plan_EtCJgbUfCcMwbl`,
		arrayId: "pro"
	},
	{
		id: 2,
		name: "Pro Plus",
		price: 479,
		terms: `Up to 500k sessions`,
		stripePlanId: isProd ? "plan_EsnkfbZvtt6DY4" : "plan_EtCLXAJ3GeMYUM",
		arrayId: "pro-plus"
	}
];

export default plansList;
